import { Component, OnDestroy } from '@angular/core';

import { finalize, Observable, Subject, takeUntil } from 'rxjs';

import { ApiPaperPlagiarismReportListItem, PaperPlagiarismCheckStatus } from 'content-manager/src/app/core/open-api/content-manager-api-client';
import { RendererBaseComponent } from 'sc-common';

@Component({
    templateUrl: './plagiarism-check-result-renderer.component.html',
    standalone: false
})
export class PlagiarismCheckResultRendererComponent extends RendererBaseComponent implements OnDestroy {

    public getViewerUrl: (item: ApiPaperPlagiarismReportListItem) => Observable<string>;
    public loadingItems = new Set<number>();

    private readonly _destroy$ = new Subject<void>();

    constructor() {
        super();
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    public getLinkText(item: ApiPaperPlagiarismReportListItem): string {

        switch (item.status) {
            case PaperPlagiarismCheckStatus.Checked:
                return `${ item.checkResult }%`;

            case PaperPlagiarismCheckStatus.Failed:
                return $localize`Error while uploading`;

            case PaperPlagiarismCheckStatus.Unchecked:
                return '';
        }
    }

    public showReport(item: ApiPaperPlagiarismReportListItem): boolean {

        if (item.status !== PaperPlagiarismCheckStatus.Checked) {
            return false;
        }

        this.loadingItems.add(item.id);

        this.getViewerUrl(item)
            .pipe(
                takeUntil(this._destroy$),
                finalize(() => this.loadingItems.delete(item.id))
            )
            .subscribe(url => {
                if (url) {
                    window.open(url, '_blank');
                }
            });

        return false;
    }
}
